import { t } from 'locales/i18n';

export const PaymentTypesOptions = [
  {
    name: t('topUpBalanceForm.creditDebitPaymentType', { ns: 'finance' }),
    value: 'card',
  },
];
